import * as Yup from 'yup';

export const RoleValueValidationSchema = Yup.object().shape({
	roleId: Yup.string().required('Role jest wymagana'),
	roleName: Yup.string().required('Rola jest wymagana'),
	validFrom: Yup.date().nullable(),
	validTo: Yup.date().nullable(),
});
